import { analyticsKeys, track } from '@mobi/account/Utils'

export type FundsManagementEvent = {
  interaction_type:
    | 'Withdrawal Started'
    | 'Withdrawal Success'
    | 'Withdrawal Error'
    | 'Withdrawal Blocked Account'
    | 'Cancel Withdrawal'
    | 'Generate PayID'
    | 'Generate PayID Success'
    | 'Generate PayID Error'
    | 'PayID Deregistered'
    | 'Select Withdrawal Speed'
    | 'How to use PayID'
    | 'Need Assistance'
  location: 'Deposit' | 'Withdrawals' | 'Transaction History' | 'OTP' | undefined
  withdrawalType: 'Fast Withdrawal' | 'Regular Withdrawal' | undefined
  message: string | undefined
}

export type FundsManagementTrackerEvent = {
  interaction_type: FundsManagementEvent['interaction_type']
} & Partial<Omit<FundsManagementEvent, 'interaction_type'>>

const initValues: Omit<FundsManagementEvent, 'interaction_type'> = {
  location: undefined,
  message: undefined,
  withdrawalType: undefined,
}

export const fundsManagementTracker = (event: FundsManagementTrackerEvent) =>
  track(analyticsKeys.fundsManagement, { ...initValues, ...event })
